import React from "react";
import { reportClientError } from "@/lib/errorReporting";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError(error?.message || "React render error", error?.stack || info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-[#F7F6F2]">
          <h1 className="font-heading text-3xl text-[#1E3F33]">Something went wrong</h1>
          <p className="text-[#5C6B64] mt-3 max-w-md">
            The error has been logged and our team has been notified. Please try reloading the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary mt-6"
            data-testid="error-boundary-reload"
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
